import Flex from '@Components/Bases/Flex';
import { SIDEBAR_WIDTH } from '@Containers/ReportLayout/Containers/SidebarContainer';
import HomeIcon from '@mui/icons-material/Home';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import { useNavigate, useParams } from 'react-router-dom';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { SectionEnum } from 'src/Enum/SectionEnum';
import EsgPlatformSaveButton from './EsgPlatformSaveButton';

export const footerHeight = 64;

const EsgPlatformFooter = () => {
  const { isPublished, breadcrumbs } = useProgressBar();
  const navigate = useNavigate();
  const { id } = useParams();

  const handlePreviewClick = () => {
    if (id) {
      const url = `/report/${id}/preview?section=${SectionEnum.EsgPlatform}`;
      window.open(url, '_blank');
    }
  };

  return (
    <Flex
      justifyContent={'space-between'}
      bgcolor={'common.white'}
      p={2}
      height={footerHeight}
      border={0}
      position="fixed"
      bottom={0}
      right={0}
      width={`calc(100vw - ${SIDEBAR_WIDTH}px)`}
      boxShadow={1}
      zIndex={zIndex.appBar}
    >
      <Button
        color="inherit"
        startIcon={<HomeIcon />}
        onClick={() => navigate(`/?report=${breadcrumbs?.reportId}`)}
      >
        กลับสู่หน้าหลัก
      </Button>
      <Flex gap={2}>
        {/* TODO: Integrate AI translator on the next phase */}
        {/* <Button disabled startIcon={<TranslateIcon />} color="inherit">
          แปลไทยเป็นอังกฤษ
        </Button> */}
        <Button
          color="inherit"
          startIcon={<VisibilityIcon />}
          onClick={handlePreviewClick}
          disabled={isPublished}
        >
          แสดงตัวอย่าง
        </Button>
        <EsgPlatformSaveButton />
      </Flex>
    </Flex>
  );
};

export default EsgPlatformFooter;
